<template>
    <div :class="classList">
        <slot />
    </div>
</template>

<script>
    import { VARIANTS } from './utils/variants';

    export default {
        name: 'C1Alert',

        props: {
            variant: {
                type: String,
                default: null,
                validator: value => VARIANTS.includes(value),
            },
        },

        computed: {
            classList() {
                return [
                    this.getDefaultClass,
                    this.getTextColorClass,
                    this.getBgColorClass,
                    this.getBorderColorClass,
                ];
            },

            getDefaultClass() {
                let output = 'af-alert';
                if (this.variant) {
                    output += ` af-alert-${this.variant}`;
                }

                output += ' afu-border afu-border-solid afu-text-sm afu-rounded mb-4 afu-px-4 afu-py-2';

                return output;
            },

            getTextColorClass() {
                return this.variant ? `afu-text-${this.variant}-400` : 'afu-text-gray-400';
            },

            getBgColorClass() {
                return this.variant ? `afu-bg-${this.variant}-50` : 'afu-bg-gray-100';
            },

            getBorderColorClass() {
                return this.variant ? `afu-border-${this.variant}-400` : 'afu-border-400';
            },
        },
    };
</script>
